import set from 'lodash/set';
import state from 'store/state/routing';
import types from 'store/types/routing';

const initialState = state;

export default function routeManagement(state = initialState, action) {
  const { key, data } = action;

  switch (action.type) {
    case types.ROUTING_SET:
      set(state, key, data);
      return { ...state };
    default:
      return state;
  }
}
